<template>
    <div class="flex flex-wrap">
        <StatsCard
            :title="$t('messages.total_research_time')"
            indicator="88 min"
            icon="user-clock"
        />

        <StatsCard
            :title="$t('messages.current_research_speed')"
            indicator="1 / min"
            icon="angle-double-right"
        />

        <StatsCard
            :title="$t('messages.current_dataset')"
            indicator="45 %"
            icon="table"
        />

        <StatsCard
            :title="$t('messages.current_challenge')"
            indicator="29 %"
            icon="clock"
        />
    </div>
</template>

<script>
    import StatsCard from '@/components/widgets/StatsCard.vue';

    export default {
        components: {StatsCard}
    }
</script>
